export class SimpleDrawObject {
    before: boolean;
    type: string;
    typeNum: number;
    location: number;
}